import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

//for dev
// const containingElem = document.querySelector("#root");
//for prod
const containingElem = document.querySelector("#react-search");

if (containingElem) {
	ReactDOM.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
		containingElem
	);
}
